//add listener when page loads
document.addEventListener('DOMContentLoaded', function () {
  const modalEls = document.querySelectorAll('.Modal');
  //set display to flex for all modalEls
  modalEls.forEach((modalEl) => {
    modalEl.style.display = 'flex';
  });
  const openEls = document.querySelectorAll('[data-open]');
  const closeEls = document.querySelectorAll('[data-close]');
  const isVisible = 'Modal--open';

  for (const el of openEls) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      const modalId = this.dataset.open;
      document.getElementById(modalId).classList.add(isVisible);
    });
  }

  for (const el of closeEls) {
    el.addEventListener('click', function (e) {
      document.querySelector('.Modal--open').classList.remove(isVisible);
      //      this.parentElement.classList.remove(isVisible);
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target == document.querySelector('.Modal--open')) {
      document.querySelector('.Modal--open').classList.remove(isVisible);
    }
  });

  document.addEventListener('keyup', (e) => {
    // if we press the ESC
    if (e.key == 'Escape' && document.querySelector('.Modal--open')) {
      document.querySelector('.Modal--open').classList.remove(isVisible);
    }
  });
});
